import LinkifyIt from "linkify-it";
import { InputRule } from "prosemirror-inputrules";
import { normalizeLink } from "./utils";
const linkify = LinkifyIt();
class LinkifyRegexMock {
    exec(str) {
        if (!str.endsWith(" ")) {
            return null;
        }
        const chunks = str.split(" ");
        const lastChunk = chunks[chunks.length - 2];
        if (!linkify.test(lastChunk)) {
            return null;
        }
        const links = linkify.match(lastChunk);
        const lastLink = links[links.length - 1];
        lastLink.length = lastLink.lastIndex - lastLink.index + 1;
        return [lastLink];
    }
}
function UrlInputHandler(state, match, start, end) {
    if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) {
        return null;
    }
    const link = match[0];
    const mark = state.schema.mark("link", { href: normalizeLink(link.url) });
    return state.tr.addMark(start, end, mark).insertText(" ");
}
export const UrlInputRule = new InputRule(new LinkifyRegexMock(), 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
UrlInputHandler);
